import React from "react"
import { graphql } from "gatsby"

import CmsPage from "@utils/cmsPage"
import { pickCollectionNode } from "@utils/cmsCollections"
import productSubpageMobileStyles from "@utils/productSubpageMobileStyles"
import { getPrototypePageSlice } from "@utils/prototypeSlices"

const prototypeSlice = getPrototypePageSlice("revenueRecovery")
const revenueRecoveryExtraStyles = `${prototypeSlice.extraStyles}${productSubpageMobileStyles}`

const RevenueRecoveryPage = ({ data }) => {
  const page = data.allDatoCmsMcV2PageFeatureDeep.nodes[0] || {}
  const sectionCollection =
    page.sectionCollection ||
    pickCollectionNode(
      data.allDatoCmsMcV2SectionCollection.nodes,
      null,
      "revenue-recovery-sections"
    )
  const hasCanonicalContent = Boolean(page.contentHtml)

  return (
    <CmsPage
      slug={page.slug}
      seo={page.seo}
      hideHero
      preserveHeroScripts
      eyebrow={page.eyebrow}
      heading={page.heading}
      summary={page.summary}
      body={page.body}
      bodyHeading={page.bodyHeading || "Feature Deep Dive"}
      heroMediaType={page.heroMediaType}
      heroImageUrl={page.heroImageUrl}
      heroImageAlt={page.heroImageAlt}
      heroVideoUrl={page.heroVideoUrl}
      heroVideoPosterUrl={page.heroVideoPosterUrl}
      contentSections={sectionCollection.contentSections || []}
      contentHtml={page.contentHtml}
      fallbackContentHtml={prototypeSlice.contentHtml}
      extraStyles={revenueRecoveryExtraStyles}
      extraHeadLinks={prototypeSlice.extraHeadLinks}
      emptyMessage="Create or seed the revenue-recovery record in mc_v2_page_feature_deep."
    />
  )
}

export default RevenueRecoveryPage

export const query = graphql`
  query RevenueRecoveryCmsPageQuery {
    allDatoCmsMcV2PageFeatureDeep(filter: { slug: { eq: "revenue-recovery" } }, limit: 1) {
      nodes {
        seo {
          ...CmsSeoFields
        }
        slug
        eyebrow
        heading
        summary
        body
        # bodyHeading  # TODO(T-014 add the Dato field, T-015 then uncomment): blocked on DatoCMS schema
        heroMediaType
        heroImageUrl
        heroImageAlt
        heroVideoUrl
        heroVideoPosterUrl
        contentHtml
        sectionCollection {
          contentSections {
            ...CmsHtmlSectionFields
          }
        }
      }
    }
    allDatoCmsMcV2SectionCollection {
      nodes {
        key
        contentSections {
          ...CmsHtmlSectionFields
        }
      }
    }
  }
`
